var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-time-picker',{staticStyle:{"width":"100%"},attrs:{"valueFormat":_vm.parameters.format,"format":_vm.parameters.format,"clearable":_vm.parameters.clearable,"placeholder":_vm.parameters.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }